import React from 'react';
import { ShieldCheck, Lock, CreditCard } from 'lucide-react';
export function TrustBadgeSection() {
  return <section className="py-12 px-4 bg-black border-y border-zinc-900" data-id="element-191">
      <div className="max-w-4xl mx-auto flex flex-col md:flex-row items-center justify-center gap-8 md:gap-16 text-center md:text-left opacity-60 hover:opacity-100 transition-opacity" data-id="element-192">
        <div className="flex items-center gap-3" data-id="element-193">
          <ShieldCheck className="w-8 h-8 text-zinc-400" data-id="element-194" />
          <div data-id="element-195">
            <p className="text-white font-bold text-sm" data-id="element-196">Garantía de 7 días</p>
            <p className="text-zinc-500 text-xs" data-id="element-197">
              Por inconvenientes de acceso
            </p>
          </div>
        </div>

        <div className="flex items-center gap-3" data-id="element-198">
          <Lock className="w-8 h-8 text-zinc-400" data-id="element-199" />
          <div data-id="element-200">
            <p className="text-white font-bold text-sm" data-id="element-201">Pago 100% Seguro</p>
            <p className="text-zinc-500 text-xs" data-id="element-202">Encriptación SSL de 256-bit</p>
          </div>
        </div>

        <div className="flex items-center gap-3" data-id="element-203">
          <CreditCard className="w-8 h-8 text-zinc-400" data-id="element-204" />
          <div data-id="element-205">
            <p className="text-white font-bold text-sm" data-id="element-206">Acceso Inmediato</p>
            <p className="text-zinc-500 text-xs" data-id="element-207">
              Recibe tu acceso al instante
            </p>
          </div>
        </div>
      </div>
    </section>;
}